export const projects = [
  {
    title: "Saw Cycle",
    subtitle: "Slice Your Way!",
    description:
      "Fun & Easy to pick-up game to play",
    image: "/SawCycle.png",
    hoverImage: "/SawCycleQR.png",
    link: "https://dang02.github.io/rock-paper-scissors/?",
  }
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "React",
  "Node",
  "Web Development - HTML/CSS/JS",
  "Material UI, Bootstrap",
  "Data Science - R, Python, PowerBI",
  "Wordpress",
  "C/C++",
  "Backend - C#/Java"
];



// WEBPACK FOOTER //
// ./src/data.js